import { captureException } from '@sentry/client';
import { ZodError } from 'zod';
import { analytics } from './analytics.ts';
import { audiences } from './audiences.ts';
import { chats } from './chats.ts';
import { sources } from './sources.ts';
import { user } from './user.ts';

export function handleApiError(
  error: unknown,
  defaultMessage?: string,
  shouldThrowError?: boolean
) {
  if (error instanceof ZodError) {
    console.error(`Schema validation error:\r\n`, error.message);
  } else {
    console.error(defaultMessage);
  }

  if (shouldThrowError) {
    // Propagate the error to handle it on upper level
    throw error;
  }

  // Send to Sentry
  captureException(error);
}

export default {
  analytics,
  audiences,
  chats,
  sources,
  user
};
